import { createSlice } from '@reduxjs/toolkit';

const shallowEqual = (a, b) => {
  const keys = Object.keys(b);
  return keys.length === Object.keys(a).length && keys.every((k) => a[k] === b[k]);
};

// Pending counts per reviewable type; feeds the sidebar badges and the overview page.
export const reviewSlice = createSlice({
  name: 'review',
  initialState: {
    summary: {},
    loading: false,
  },
  reducers: {
    getReviewSummaryAction: (state) => {
      state.loading = true;
    },
    getReviewSummarySuccess: (state, action) => {
      const next = action.payload?.data || {};
      // Same counts must keep the same object: `summary` drives the nav memo,
      // and a new identity every poll rebuilds the whole sidebar.
      if (!shallowEqual(state.summary, next)) state.summary = next;
      state.loading = false;
    },
    getReviewSummaryFailure: (state) => {
      // Keep the last counts; a failed poll must not blank the badges.
      state.loading = false;
    },
  },
});

export const { getReviewSummaryAction, getReviewSummarySuccess, getReviewSummaryFailure } =
  reviewSlice.actions;
